import ActionConstants from '../constants';

export const cancelApiRequestAction = (
  cancelKey: string | string[]
): {
  type: string;
  payload: { cancelKey?: string; cancelKeys?: string[] };
} => {
  const payload = Array.isArray(cancelKey)
    ? { cancelKeys: cancelKey }
    : { cancelKey };

  return {
    type: ActionConstants.CANCEL_API_REQUEST,
    payload,
  };
};
